package com.trevorwiebe.timesheet.signin.data

import com.trevorwiebe.timesheet.core.data.Utils.errorWrapper
import com.trevorwiebe.timesheet.core.domain.CoreRepository
import com.trevorwiebe.timesheet.core.domain.TSResult
import com.trevorwiebe.timesheet.signin.domain.Authenticator
import dev.gitlive.firebase.Firebase
import dev.gitlive.firebase.auth.auth
import dev.gitlive.firebase.functions.functions

class AuthImpl(
    private val firebase: Firebase,
    private val coreRepository: CoreRepository
): Authenticator {

    override suspend fun getSignedInUser(): TSResult {
        return coreRepository.getFirebaseUser()
    }

    override suspend fun signIn(email: String, password: String): TSResult {
        return errorWrapper{
            val firebaseAuth = firebase.auth
            val firebaseUser = firebaseAuth.signInWithEmailAndPassword(email, password).user
            if(firebaseUser == null) {
                TSResult(error = "User was null")
            }else{
                TSResult(data = firebaseUser)
            }
        }
    }

    override suspend fun resetPassword(email: String): TSResult {
        return errorWrapper {
            Firebase.functions
                .httpsCallable("sendPasswordResetEmail")
                .invoke(PasswordResetRequest(email = email))
            TSResult(data = "Reset password email sent")
        }
    }

    override suspend fun signOut(): TSResult {
        return coreRepository.signOut()
    }
}